import React from 'react';
import { Tooltip } from 'reactstrap';

const rxNumberPattern = /^((\d+)?(-{1})?\d+)+$/;

export default class RxNumber extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        const { value, setFocus, rxNumberId, touched } = this.props;
        this.state = { tooltipOpen: false, value: value ? value : '', valueEntered: false, touched: touched };

        if (setFocus) {
            const input = document.getElementById(rxNumberId);
            if (input) {
                input.focus();
            }
        }
    }

    toggleTooltip() {
        this.setState({ tooltipOpen: !this.state.tooltipOpen });
    }

    onBlur(event) {
        const { valueEntered, touched } = this.state;
        if (valueEntered && !touched) {
            this.setState({ touched: true });
        }
    }

    onKeyUp(event) {
        if (event.keyCode === 8 || event.keyCode === 46) { // when backspace or delete key are pressed
            const target = event.target;
            const start = target.selectionStart;
            const value = target.value;
            target.value = value.replace(/[^\d\-]/g, '').replace(/--/g, '-');
            target.selectionEnd = target.selectionStart = start;
        }
    }

    onKeyPress(event) {
        if (event.charCode && !event.ctrlKey && !event.altKey) {
            this.filterRxNumber(event.key, event);
        }
    }

    onPaste(event) {
        const data = window.clipboardData ? window.clipboardData.getData('text') : event.clipboardData.getData('text/plain');
        this.filterRxNumber(data, event);
    }

    isValid(value) {
        const { minLength } = this.props;
        var minInputLength = minLength ? minLength : 0;
        return (value.trim() && rxNumberPattern.test(value) && value.match(/\d/g).join('').length >= minInputLength);
    }

    filterRxNumber(str, event) {
        var target = event.target;
        var value = target.value;
        var start = target.selectionStart;
        var end = target.selectionEnd;
        var length = 0;

        var filtered = str;

        if (str) {
            if (start === 0 && str && str[0] === '-') {
                filtered = filtered.replace(/[\-]+/, '');
            }

            filtered = filtered.replace(/[^\d\-]/g, '');//.replace(/--/g, '-');

            if (value[start - 1] === '-' && filtered[0] === '-') {
                filtered = filtered.substr(1);
            }

            length = filtered.length;

            if (length > 0 && filtered[length - 1] === '-' && value[end] === '-') {
                filtered = filtered.substr(0, length - 1);
            }

            if (filtered.length > 0) {
                value = value.substr(0, start) + filtered + value.substr(end);
                //value = value.replace(/--/g, '-');
            }
        }

        if (target.value !== value) {
            target.value = value;
            target.selectionEnd = start + length;
        }

        target.selectionStart = target.selectionEnd;

        event.preventDefault();
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
        const event2 = document.createEvent('Event'); //new Event('input', { bubbles: true });
        event2.initEvent('init', true, true);
        nativeInputValueSetter.call(target, value);
        target.dispatchEvent(event2);

        const isValid = this.isValid(value);
        this.props.onChange(event, isValid);
        this.setState({ value, valueEntered: true });

        return filtered;
    }

    onChange(event) {
        const value = event.target.value;
        const isValid = this.isValid(value);
        this.props.onChange(event, isValid);
        this.setState({ value });
    }

    render() {
        const { placeholder, rxNumberId, required, inputErrorMsg, tooltipID, tooltipMsg, onChange, value, showAsInvalid } = this.props;
        const { touched } = this.state;
        const actualValue = value ? value : this.state.value;
        const notEmptyClass = actualValue ? " input-not-empty" : "";
        const invalidClass = !showAsInvalid && (!touched || (!required && !actualValue) || this.isValid(actualValue)) ? "" : " input-invalid";
        const containerClassName = notEmptyClass + invalidClass + ((tooltipID && tooltipMsg) ? " input-append" : "");

        return (
            <div className={`il-group ${containerClassName} ${showAsInvalid ? ` input-invalid` : ``}`}>
                <input type="text" id={rxNumberId} value={onChange ? actualValue : this.state.value} className="form-control" required={required}
                    placeholder={placeholder ? placeholder : "Active RX Number"}
                    onKeyUp={e => this.onKeyUp(e)} onKeyPress={e => this.onKeyPress(e)} onBlur={e => this.onBlur(e)}
                    onChange={e => this.onChange(e)} onPaste={e => this.onPaste(e)} value={actualValue}
                    title={placeholder ? "Please fill out the " + placeholder : "Please fill out the Active RX Number."}
                    aria-label={placeholder ? placeholder : "Active RX Number"}                    
                />
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleTooltip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                <div className="il-label" aria-hidden="true">{placeholder}</div>
                {inputErrorMsg && <div className="input-error-msg">{inputErrorMsg}</div>}
            </div>
        );
    }
}